import React from 'react';
import __ from 'lodash';

class DropdownProdi extends React.Component{
    render() {
        return (
            this.props.prodi.map((val) =>
                <option key={val.idProdi} value={val.idProdi}>{val.namaProdi}</option>
            )            
        )
    }
}

export default DropdownProdi;